import { useState } from 'react';
import request from 'app/api/request';
import { dispatchReportError, dispatchReportErrorKey } from './reportErrorToast';

export interface UseDownloadReportPackageInput {
  documentSuperId: string;
  documentRevisionId: string | undefined;
  documentLocale: string | undefined;
}

export function useDownloadReportPackage({ documentSuperId, documentRevisionId, documentLocale }: UseDownloadReportPackageInput) {
  const [isDownloading, setIsDownloading] = useState(false);

  const download = async () => {
    if (isDownloading) return;
    if (!documentRevisionId) {
      dispatchReportErrorKey('export');
      return;
    }
    setIsDownloading(true);
    try {
      const url = `/gaby/report-package?documentSuperId=${documentSuperId}&documentRevisionId=${documentRevisionId}${
        documentLocale ? `&locale=${documentLocale}` : ''
      }`;
      const res = await request.get(url, { expectBinary: true } as any);
      const blob = res.data as Blob;
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = window.document.createElement('a');
      a.href = downloadUrl;
      const cd = (res as any).headers?.['content-disposition'] ?? '';
      const match = cd.match(/filename="?([^";]+)"?/);
      a.download = match?.[1] ?? 'report-package.zip';
      a.click();
      window.URL.revokeObjectURL(downloadUrl);
    } catch (err: any) {
      dispatchReportError('export', err);
    } finally {
      setIsDownloading(false);
    }
  };

  return { download, isDownloading };
}
